/*
 *  Campaign__Create_ATS__styles.js
 *
 *
 *
 */
//==============================================================================
// External dep.
//==============================================================================
import styled from "styled-components";
//------------------------------------------------------------------------------
// Components
//------------------------------------------------------------------------------
const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.sizes.campaignCreation.navigationHeight};

  .boxsizingBorder {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
`;

const QualificationsWrapper = styled.div`
  background-color: white;
  width: ${(props) => (props.fullWidth ? "100%" : "800px")};
  padding: 32px;
  margin-bottom: 16px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
`;

const ChatbotWrapper = styled.div`
  background-color: white;
  width: ${(props) => (props.fullWidth ? "100%" : "800px")};
  padding: 32px;
  margin-bottom: 16px;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  height: 300px;
`;

const HeaderSection = styled.div`
  display: flex;
  align-items: flex-end;
  position: relative;
  flex-direction: column;
`;

const SectionHeaderDescription = styled.div`
  text-align: left;
  margin: op;
  margin-top: 10px;
  font-size: 12px;
  line-height: 18px;
  font-family: "Public Sans";
  color: #302e38;
`;

const HeaderSectionTop = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
`;

const HeaderTitle = styled.span`
  height: 32px;
  font-family: Public Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 32px;
  display: flex;
  align-items: center;
  color: #302e38;
`;

const HeaderExtra = styled.span`
  height: 25px;
  font-family: Public Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;

  display: flex;
  align-items: center;
  text-align: center;

  color: #5f5c70;
  margin: 0px 8px;
`;

const FormalityItem = styled.span`
  height: 25px;
  font-family: Public Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;

  display: flex;
  align-items: center;
  text-align: center;
  margin: 0px 4px;

  color: #5f5c70;
`;

const FormalitySection = styled.span`
  display: flex;
  top: 8px;
  right: 5px;
  justify-content: center;
  margin-top: 8px;
`;

const BreakLine = styled.div`
  height: 0px;
  margin: 24px auto;
  border: 1px solid #f0f0f0;
`;

const BreakLineDashed = styled.div`
  height: 0px;
  margin: 24px auto;
  border: 1px dashed #f0f0f0;
`;

const DeleteButtonQuestion = styled.img`
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s linear 300ms, opacity 300ms;

  cursor: pointer;
  height: 26px;
  &:hover {
    filter: brightness(0.5);
  }
`;

const QuestionSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  transition: all 0.3s;
  &:hover ${DeleteButtonQuestion} {
    visibility: visible;
    opacity: 1;
    transition: visibility 0s linear 0s, opacity 300ms;
  }
`;
const AnswersSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 14px 0px 0px 10px;
  width: 100%;
  box-shadow: -0.5px 0 0 #d6d5dd;
  padding-left: 16px;
`;

const QuestionHeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 8px 0px;
  align-items: flex-end;
  width: 100%;
  position: relative;

  height: 16px;
`;

const QuestionHeaderTitle = styled.span`
  color: blue;
  margin: 0px 0px;
  height: 16px;

  font-family: Public Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
`;

const QuestionWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const QuestionNumberWrapper = styled.div`
  min-height: 22px;
  min-width: 22px;
  line-height: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8066ff;
  font-weight: 900;
  padding: 3px;
  border-radius: 32px;
  z-index: 100;
  margin-right: 10px;
  border: 1px solid #8066ff;
`;

const AddAnswerPlaceholder = styled.span`
  height: 16px;
  padding: 0px 4px;
  width: 100%;
  background: none;
  text-align: start;

  font-family: Public Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;

  color: #928fa3;
  cursor: pointer;

  &:hover {
    color: #302e38;
  }
`;

const AddQuestionPlaceholder = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 24px;
  padding: 0px 4px;
  width: 100%;
  background: none;

  font-family: Public Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 24px;

  color: ${(props) => (props.isActive ? "#302E38" : " #928FA3")};
  cursor: pointer;

  &:hover {
    color: #302e38;
  }
`;

const DeleteButton = styled.img`
  visibility: hidden;
  position: absolute;
  opacity: 0;
  transition: visibility 0s linear 300ms, opacity 300ms;
  top: 12px;
  right: 0px;
  cursor: pointer;
  &:hover {
    filter: brightness(0.5);
  }
`;

const CheckboxArea = styled.div`
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s linear 300ms, opacity 300ms;

  position: absolute;
  top: 12px;
  right: 40px;
`;

const AnswerDisqualifyingActive = styled.span`
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s linear 300ms, opacity 300ms;

  position: absolute;
  top: 12px;
  right: 70px;

  height: 16px;
  font-family: Public Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  color: #928fa3;
  margin: 0px 8px;
`;

const AnswerDisqualifying = styled.span`
  visibility: visible;
  position: absolute;
  top: 12px;
  right: 100px;

  height: 16px;
  font-family: Public Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 24px;
  color: #928fa3;
  margin: 0px 8px;
`;

const AnswerWrapper = styled.div`
  position: relative;
  &:hover ${DeleteButton} {
    visibility: visible;
    opacity: 1;
    transition: visibility 0s linear 0s, opacity 300ms;
  }
  &:hover ${CheckboxArea} {
    visibility: visible;
    opacity: 1;
    transition: visibility 0s linear 0s, opacity 300ms;
  }
  &:hover ${AnswerDisqualifyingActive} {
    visibility: visible;
    opacity: 1;
    transition: visibility 0s linear 0s, opacity 300ms;
  }
  &:hover ${AnswerDisqualifying} {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s linear 300ms, opacity 300ms;
  }
`;

const AnswerEditing = styled.textarea`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 16px;
  height: 48px;
  margin: 0px 8px 8px 0px;
  background: #f9f8fb;

  padding: 16px 16px;

  font-family: Public Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
  color: #302e38;
  width: 96%;

  border: 1px solid transparent;
  border-radius: 4px;

  resize: none;

  overflow: hidden;

  &:focus {
    border: 1px solid #1e22ff;
    box-shadow: 0 0 10px rgb(3 169 244 / 20%);
    background: white;
  }
`;

const AnswerEditingError = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 16px;
  margin: 0px 8px 8px 0px;

  font-family: Public Sans;
  font-style: normal;
  font-size: 12px;
  line-height: 16px;
  color: #ff985c;
  width: 96%;

  border: 1px solid transparent;
  border-radius: 4px;
`;

const QuestionTypesWrapper = styled.div`
  display: flex;
`;

const QuestionType = styled.div`
  margin: 8px;
  cursor: pointer;
  padding: 10px 4px;
  width: 100%;
  background: none;

  font-family: Public Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;

  color: #928fa3;
  cursor: pointer;

  border: 1px solid #eee;
  border-radius: 10px;

  transition: all 0.3s;

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  &:hover {
    color: #302e38;
    background: #eee;
  }
`;

const FreeFormText = styled.span`
  height: 16px;
  padding: 0px 4px;
  background: none;
  text-align: start;
  border-bottom: 1px dashed #f0f0f0;
  width: 50%;
  margin: 8px 0px;

  font-family: Public Sans;
  font-style: italic;
  font-size: 12px;
  line-height: 16px;

  color: #928fa3;
`;

const WelcomeMessageSection = styled.div`
  padding: 0px 4px;
  background-color: #f2f5f7;
  text-align: start;
  margin-bottom: 8px;
  width: 70%;
  border: 1px solid transparent;
  border-radius: 10px;
  padding: 10px;

  font-family: Public Sans;
  font-size: 14px;
  line-height: 16px;

  color: #1e1f46;
`;

const WelcomeMessageReplySection = styled.div`
  padding: 0px 4px;
  background-color: #f2f5f7;
  text-align: end;
  margin-bottom: 8px;
  margin-top: 30px;
  width: 65%;
  float: right;
  border: 1px solid transparent;
  border-radius: 10px;
  padding: 10px;

  font-family: Public Sans;
  font-size: 14px;
  line-height: 16px;

  color: #1e1f46;
`;

const SelectMenuStylesHidden = {
  container: (provided = {}) => ({
    ...provided,
    width: "100%",
    fontFamily: "Public Sans",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "16px",
    lineHeight: "24px",
    marginRigtht: "-8px",
    color: "#302E38"
  }),
  control: (provided = {}) => ({
    ...provided,
    display: "none"
  }),

  option: (provided = {}) => ({
    ...provided,
    textAlign: "start",
    fontSize: "14px",
    fontWeight: "500",
    color: "#5F5C70"
  }),
  dropdownIndicator: () => ({
    display: "none"
  }),
  indicatorsContainer: () => ({
    display: "none"
  }),
  menu: (provided) => ({
    ...provided,
    overflow: "visible",
    width: "93%",
    margin: "8px 0px 8px 25px"
  }),
  menuList: (provided) => ({
    ...provided,
    padding: "0px"
  })
};

const SelectMenuStyles = {
  container: (provided = {}, state) => {
    return {
      ...provided,
      width: "100%",
      fontFamily: "Public Sans",
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "16px",
      lineHeight: "24px",
      marginRigtht: "-8px",
      color: "#302E38",
      ...(state?.getValue()?.length ? {} : { border: "1px solid red", borderRadius: "5px" })
    };
  },

  option: (provided = {}, state) => ({
    ...provided,
    textAlign: "start",
    fontSize: "14px",
    fontWeight: "normal",
    color: state.isSelected ? "white" : "#5F5C70"
  }),
  menu: (provided) => ({
    ...provided,
    overflow: "visible"
  }),
  menuList: (provided) => ({
    ...provided,
    padding: "0px"
  })
};

const ModalTemplates__ButtonsContainer = styled.div`
  width: 100%;
  /* layout */
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  /* space between buttons */
  & button:not(:first-child) {
    margin-left: 20px;
  }
`;

const QuestionEditing = styled.textarea.attrs((props) => ({
  cols: "100",
  rows: "1",
  placeholder: props.questionError
}))`
  margin: 0px 0px 0px -8px;
  text-align: start;
  padding: 4px 7px;

  font-family: Public Sans;
  font-style: normal;
  font-weight: ${(props) => (props.questionError ? "normal" : "bold")};
  font-size: 16px;
  line-height: 24px;

  color: #302e38;
  width: 100%;

  border: 1px solid transparent;
  border-radius: 4px;
  background: ${(props) => (props.questionError ? "#FFD8C2" : "none")};

  resize: none;
  transition: background 300ms;

  &:hover {
    background: ${(props) => (props.questionError ? "#FFD8C2" : "#eee")};
  }

  &:focus {
    border: 1px solid #1e22ff;
    box-shadow: 0 0 10px rgb(3 169 244 / 20%);
    background: white;
    color: #302e38;
  }

  overflow: hidden;

  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: ${(props) => (props.questionError ? "#FF985C" : "#302E38")};
    opacity: 1; /* Firefox */
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: ${(props) => (props.questionError ? "#FF985C" : "#302E38")};
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: ${(props) => (props.questionError ? "#FF985C" : "#302E38")};
  }
`;

export {
  MainWrapper,
  QualificationsWrapper,
  ChatbotWrapper,
  HeaderSection,
  HeaderTitle,
  HeaderExtra,
  FormalitySection,
  FormalityItem,
  BreakLine,
  BreakLineDashed,
  DeleteButtonQuestion,
  QuestionSection,
  AnswersSection,
  QuestionHeaderSection,
  QuestionHeaderTitle,
  AddAnswerPlaceholder,
  AddQuestionPlaceholder,
  QuestionEditing,
  SelectMenuStylesHidden,
  SelectMenuStyles,
  DeleteButton,
  CheckboxArea,
  AnswerEditingError,
  AnswerWrapper,
  AnswerEditing,
  QuestionTypesWrapper,
  QuestionType,
  FreeFormText,
  WelcomeMessageSection,
  WelcomeMessageReplySection,
  QuestionWrapper,
  QuestionNumberWrapper,
  HeaderSectionTop,
  SectionHeaderDescription,
  ModalTemplates__ButtonsContainer
};
